import axios from "axios";
import { getApiConfig } from "./config.js";

export const APISendForgetPasswordEmail = async(email, setLoading) => {
    setLoading(true);

    try {
        const apiConfig = getApiConfig();
        const result = await axios.get(`${apiConfig.baseURL}/admin/forgotPass/${email}`, {
            headers: apiConfig.headers
        });

        return result
    } catch (error) {
        console.error('Error Sending Reset Password email: ', error);
        return error
    } finally {
        setLoading(false);
    }
}

export const APIResetPassword = async(adminData, setLoading) => {
    setLoading(true);

    try {
        const apiConfig = getApiConfig();
        const result = await axios.post(`${apiConfig.baseURL}/admin/resetPass`, adminData, {
            headers: apiConfig.headers
        });

        return result
    } catch (error) {
        console.error('Error Resetting Password: ', error);
        return error
    } finally {
        setLoading(false);
    }
}

export const APIResetParentPassword = async(parentData, setLoading) => {
    setLoading(true);

    try {
        const apiConfig = getApiConfig();
        const result = await axios.post(`${apiConfig.baseURL}/parent/resetPass`, parentData, {
            headers: apiConfig.headers
        });
        
        return result
    } catch (error) {
        console.error('Error Resetting Password: ', error);
        return error
    } finally {
        setLoading(false);
    }
}